import React from 'react';
import PropTypes from 'prop-types';
import './baiMatrixQuestion.css';

const BASE_LABELS = ['Siempre', 'Casi siempre', 'Algunas veces', 'Casi nunca', 'Nunca'];

const getOptions = (question) => {
  const effectiveLabels = Array.isArray(question.labels) && question.labels.length > 0
    ? question.labels
    : BASE_LABELS;

  return effectiveLabels.map((label, idx) => ({
    label,
    value: question.invertOrder ? idx : effectiveLabels.length - 1 - idx
  }));
};

export default function BaiMatrixQuestion({ questions, values, onAnswer }) {
  if (!questions.length) return null;

  const headers = getOptions(questions[0]).map((option) => option.label);

  return (
    <div className="bai-matrix-wrapper">
      <table className="bai-matrix-table">
        <thead>
          <tr>
            <th>Afirmación</th>
            {headers.map((header) => (
              <th key={header}>{header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {questions.map((question) => {
            const rowOptions = getOptions(question);
            const currentValue = values[question.field];

            return (
              <tr key={question.field}>
                <td className="bai-matrix-question-cell">
                  {question.question}
                  {question.required && <span className="required"> *</span>}
                </td>
                {headers.map((header) => {
                  const option = rowOptions.find((item) => item.label === header);
                  if (!option) {
                    return <td key={`${question.field}-${header}`} />;
                  }

                  return (
                    <td key={`${question.field}-${header}`} className="bai-matrix-option-cell">
                      <input
                        type="radio"
                        name={question.field}
                        value={option.value}
                        checked={currentValue === option.value}
                        onChange={() => onAnswer(question.field, option.value)}
                      />
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

BaiMatrixQuestion.propTypes = {
  questions: PropTypes.arrayOf(
    PropTypes.shape({
      field: PropTypes.string.isRequired,
      question: PropTypes.string.isRequired,
      required: PropTypes.bool,
      labels: PropTypes.arrayOf(PropTypes.string),
      invertOrder: PropTypes.bool
    })
  ).isRequired,
  values: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired,
  onAnswer: PropTypes.func.isRequired
};
